import type React from "react";
import type { User } from "../../types/user";
import InitialsAvatar from "./InitialsAvatar";

export type UserAvatarUser = Pick<User, "_id"> & Partial<Pick<User, "name" | "username">>;

interface UserAvatarProps {
  user: UserAvatarUser | null | undefined;
  size?: number;
  tooltipText?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ user, size = 32, tooltipText }) => {
  const displayName = user?.name || user?.username || user?._id || "User";

  return <InitialsAvatar name={displayName} size={size} tooltipText={tooltipText} />;
};

export default UserAvatar;
